<template>
  <div>
    <Input title="Subdomains" placeholder="foxnews.com" description="See which subdomains and attack surfaces Webscout has observed for a given domain." :loading="loading" @submit="handle"/>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Input from '@/components/Blocks/Box/Input.vue'
import { useQueryStore } from '@/stores/query'
import { useMainStore } from '@/stores/main'
import Domain from '@/api/Domain'
import CellExpandedSlideover from '@/components/Query/CellDataSlideover.vue'
let mainStore = useMainStore()
let queryStore = useQueryStore()
import QueryRunner from '@/views/Authenticated/Query/Runner.vue'

const loading = ref(false)

async function handle(domain) {
  domain = domain.toLowerCase()
  mainStore.show_slideover(QueryRunner, { input: [domain], type: "subdomains" }, { width: 10 }, "(subdomains) "+domain) 
}
</script>

<style scoped>

</style>
